module.exports = __webpack_public_path__ + "img/image14.30b146e4.png";